module.exports = __webpack_public_path__ + "img/3_uk.10517637.svg";